var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLngArrow = function SvgLngArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#A6A7B0",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "m2 5 5.93 5.84a.1.1 0 0 0 .14 0L14 5"
  })));
};
export { SvgLngArrow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9Imljb25zIj4KPHBhdGggaWQ9IlZlY3RvciA1IiBkPSJNMiA1TDcuOTI5ODMgMTAuODQwMUM3Ljk2ODc2IDEwLjg3ODUgOC4wMzEyNCAxMC44Nzg1IDguMDcwMTcgMTAuODQwMUwxNCA1IiBzdHJva2U9IiNBNkE3QjAiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CjwvZz4KPC9zdmc+Cg==";